import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/BillingBrand.service";

import {
  BRAND_BILLING_QUERY_KEY,
  ORGANISATION_LIST_QUERY_KEY,
} from "@entities/organisation/lib/constants";
import { IBrandBilling } from "@shared/lib/types/brandBilling";
import {
  BILLING_BRAND_DETAILS_QUERY_KEY,
  BILLING_BRAND_LIST_QUERY_KEY,
} from "../constants";

interface EditBrandBillingParams {
  billingId: string;
  brandBilling: Partial<IBrandBilling>;
}

export function useEditBrandBilling(
  brandOrganisationId?: string,
  brandId?: string
) {
  const {
    mutate: edit,
    isLoading: isEditing,
    isSuccess: isEdited,
    error,
  } = useMutation<EditBrandBillingParams>({
    mutationFn: async ({ billingId, brandBilling }) => {
      try {
        return await CampaignService.editBrandBilling(billingId, brandBilling);
      } catch (err: any) {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }
    },
    options: {
      queryKey: BILLING_BRAND_LIST_QUERY_KEY,
    },
    onSuccess: (c, data, params) => {
      c.invalidateQueries({ queryKey: BILLING_BRAND_LIST_QUERY_KEY });
      c.invalidateQueries({
        queryKey: [...BRAND_BILLING_QUERY_KEY, brandId],
      });

      c.invalidateQueries({
        queryKey: BILLING_BRAND_DETAILS_QUERY_KEY(params.billingId),
      });

      if (brandOrganisationId) {
        c.invalidateQueries({
          queryKey: [...ORGANISATION_LIST_QUERY_KEY, brandOrganisationId],
        });
      }
    },
  });

  return {
    edit,
    isEditing,
    isEdited,
    error,
  };
}
